import React, { FC, ReactNode, useEffect } from "react";
import { useIdToken } from "react-firebase-hooks/auth";

import { firebaseAuth } from "../configs/firebase";
import {
  useCompleteOnboardingMutation,
  useUpdateCurrentUserInfoMutation,
} from "../store/pomeriumApi";
import { UserContext } from "./user-context-definition";

export type UserProviderProps = {
  children?: ReactNode | undefined;
};

export const UserProvider: FC<UserProviderProps> = ({ ...props }) => {
  const [user] = useIdToken(firebaseAuth);
  const [updateCurrentUserInfo, { data: pomeriumUser }] =
    useUpdateCurrentUserInfoMutation();
  const [, { isSuccess: completedOnboarding }] = useCompleteOnboardingMutation({
    fixedCacheKey: "complete-onboarding",
  });
  // the user endpoint is not like other endpoints, it has no "get", so cache clearing doesn't work
  // instead we use the complete-onboarding mutation to signal that we called complete and the user
  // is done with onboarding.
  const pomUser = pomeriumUser && {
    ...pomeriumUser,
    needsOnboarding: pomeriumUser.needsOnboarding && !completedOnboarding,
  };

  useEffect(() => {
    if (user?.uid && user?.emailVerified) {
      user.getIdToken(true).then(() => updateCurrentUserInfo());
    }
  }, [user?.uid, user?.emailVerified]);

  return (
    <UserContext.Provider
      {...props}
      value={{ user: pomUser }}
    ></UserContext.Provider>
  );
};

export {
  UserContext,
  UserConsumer,
  type UserState,
} from "./user-context-definition";
